import { SelectAsyncInput } from '@core/components/Select';
import { centroCustoApi } from 'app/services/api/centroCustoApi';
import React from 'react';

const SelectGrupoCentroCusto = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  disabled,
  tipoNatureza,
}) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      required={required}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await centroCustoApi().buscarGrupo({
          size: 100,
          page: next,
          q: query,
          tipoNatureza: tipoNatureza,
        });

        // const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectGrupoCentroCusto;
